// extracted by mini-css-extract-plugin
export default {"wixStudioToolBar":"rzK_I5","logo":"YpeHZ9","switcher":"c3f9dg"};